export default function Setup() {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-4xl font-bold mb-4">Setup Wizard</h1>
        <p className="text-lg text-muted-foreground">Setup page placeholder</p>
      </div>
    </div>
  );
}
